import { createApi } from "@reduxjs/toolkit/query/react";

import { type IApiResponse } from "@/shared/interfaces/api-response.interface";
import type { IDistrictImportJobStatusResponse } from "@/shared/interfaces/district-import.interface";

import customFetchBase from "../custom-fetch-base";

const importsApi = createApi({
  reducerPath: "importsApi",
  baseQuery: customFetchBase,
  tagTypes: [],
  endpoints: (builder) => ({
    getDistrictImportJobStatus: builder.query<IDistrictImportJobStatusResponse, string>({
      query: (jobId) => ({
        url: `/imports/jobs/${encodeURIComponent(jobId)}`,
        method: "GET",
      }),
      transformResponse: (
        result:
          | IApiResponse<IDistrictImportJobStatusResponse>
          | { statusCode: number; data: IDistrictImportJobStatusResponse; [key: string]: unknown },
      ) => {
        if ("data" in result && result.data) {
          return result.data;
        }
        return result as unknown as IDistrictImportJobStatusResponse;
      },
    }),
  }),
});

export const { useLazyGetDistrictImportJobStatusQuery } = importsApi;
export default importsApi;
